import { render, staticRenderFns } from "./AuditChangeLogTable.vue?vue&type=template&id=c5f2c618"
import script from "./AuditChangeLogTable.vue?vue&type=script&lang=js"
export * from "./AuditChangeLogTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports